import { SearchOutlined, CloseOutlined } from '@ant-design/icons'
import appStore from '@stores/appStore'
import { SizeType } from 'antd/lib/config-provider/SizeContext'
import { ReactComponent as RefreshIcon } from 'assets/svg/refresh-cw.svg'
import { AppButton } from '../AppComponents'
import { useContext } from 'react'
import { TableFilterContext } from './TableContext'

type Props = {
  loading?: boolean
  disable?: boolean
  handleExport?: () => void
  buttonSize?: SizeType
  addNewButton?: JSX.Element
}

const TableDefaultButton = ({
  loading = false,
  disable = false,
  buttonSize = 'middle',
  handleExport = null,
  addNewButton = null,
}: Props) => {
  const iconSize = buttonSize === 'large' ? 18 : 14
  const filterContext = useContext(TableFilterContext)
  const doRefresh = filterContext.handleRefresh
  const doSearch = filterContext.handleSearch
  const doReset = filterContext.handleReset
  return (
    <div className="flex gap-2">
      <AppButton
        disabled={loading || disable}
        onClick={() => doSearch?.()}
        color="blue"
        size={buttonSize}
        circle
        title="Search"
      >
        <SearchOutlined className="inline" width={iconSize} height={iconSize} />
      </AppButton>
      {doRefresh && (
        <AppButton
          disabled={loading || disable}
          onClick={() => doRefresh()}
          type="primary"
          color="green"
          shape="circle"
          size={buttonSize}
          title="Refresh"
        >
          <RefreshIcon className="inline" width={iconSize} height={iconSize} />
        </AppButton>
      )}
      {doReset && (
        <AppButton
          disabled={loading || disable}
          onClick={() => doReset()}
          color="red"
          size={buttonSize}
          circle
          className=""
          title="Clear All Filters"
        >
          <CloseOutlined
            className="inline"
            width={iconSize}
            height={iconSize}
          />
        </AppButton>
      )}
      {addNewButton}
      {(appStore.edition.FUNDING_PROVIDER || appStore.edition.MLP) &&
        appStore.isAdminOrStaff &&
        handleExport && (
          <AppButton
            onClick={() => handleExport()}
            disabled={loading}
            type="primary"
            color="green"
            rounded
            size={buttonSize}
            tooltip={
              <div>
                Data export will be in multiple files of 500 records each.
              </div>
            }
          >
            Download Search Results
          </AppButton>
        )}
    </div>
  )
}

export default TableDefaultButton
